module.exports = __webpack_public_path__ + "img/productVibration_5.876f17bd.png";